module.exports = __webpack_public_path__ + "img/中建新疆建工.6dc4198d.png";